import { CountryCode, parsePhoneNumberWithError } from "libphonenumber-js";
import { StorageUploadPresignRequest } from "../types/api.types";

const passwordRegex =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^a-zA-Z0-9\s])[A-Za-z\d\S]{8,16}$/;

const validatePhoneNumber = (
  _: any,
  value: string,
  selectedCountry: CountryCode
) => {
  if (!value) {
    return Promise.reject("Phone number is required");
  }

  try {
    const phoneNumber = parsePhoneNumberWithError(value, selectedCountry);
    if (!phoneNumber.isValid()) {
      return Promise.reject("Invalid phone number format");
    }
    return Promise.resolve();
  } catch (error) {
    return Promise.reject("Invalid phone number format");
  }
};

const validatePassword = (_: any, value: string, isRequired: boolean) => {
  if (value) {
    if (!passwordRegex.test(value)) {
      return Promise.reject(
        "Password must be between 8 and 16 characters and contain at least one uppercase letter, one lowercase letter, one number, and one special character"
      );
    }
  } else if (isRequired) {
    return Promise.reject("Password is required");
  }
  return Promise.resolve();
};

const validateStorageUploadPresignRequest = (
  _: any,
  value: StorageUploadPresignRequest
): Promise<string> => {
  if (!value.contentType || !value.contentType.match(/^image\/(jpeg|png)$/)) {
    return Promise.reject("Only JPEG and PNG images are supported");
  }
  if (value.contentLength < 10 * 1024) {
    return Promise.reject("Content length must be greater than 10KB");
  }
  if (value.contentLength > 2 * 1024 * 1024) {
    return Promise.reject("Content length must be less than 2MB");
  }
  if (value.duration < 1) {
    return Promise.reject("Duration must be greater than 1 minute");
  }
  if (value.duration > 10) {
    return Promise.reject("Duration must be less than 10 minutes");
  }
  return Promise.resolve("valid");
};

export {
  passwordRegex,
  validatePassword,
  validatePhoneNumber,
  validateStorageUploadPresignRequest,
};
